const UNIT_KEYS = {
  views: 'ranks.units.views',
  campaigns: 'ranks.units.campaigns',
  renders: 'ranks.units.clips',
} as const;

export function rankMetricUnitKey(trackId: string): string | null {
  if (trackId in UNIT_KEYS) {
    return UNIT_KEYS[trackId as keyof typeof UNIT_KEYS];
  }
  return null;
}

export function joinRankMetricUnit(
  formatted: string,
  unit?: string | null,
): string {
  const suffix = unit?.trim();
  return suffix ? `${formatted} ${suffix}` : formatted;
}
